// French Canadian (Language-Country Code: fr-CA) Locale File.

import defaultsDeep from 'lodash.defaultsdeep';

import { PublicLocalizationObject } from './en_US';
import fr_FR from './fr_FR';

const fr_CA: PublicLocalizationObject = defaultsDeep(
    {
        general: {
            currentLanguage: 'Français (Canada)',
            confirm: 'Confirmer',
        },

        tabs: {
            myTicketsAndPasses: 'Mes billets / passes',
        },
        events: {
            dataAttribute: {
                MAILING_ADDRESS: {
                    state: 'Province',
                },
                OPT_IN: "Consentir au partage d'adresse courriel",
            },
            ageRatingUrl: 'https://www.esrb.org/ratings-guide/fr/',
        },
        activities: {
            details: {
                alreadyRSVPd: 'Vous possédez déjà une passe pour cette activité.',
            },
        },
        reservations: {
            event_registration: {
                attendeeCannotRegister:
                    "les participants ne peuvent s'inscrire pour plus d'une activité durant le même créneau horaire ni à la même activité plus d'une fois.",
                currentUserIneligible:
                    'Vous êtes déjà inscrit(e) pour une passe donnant accès à cette activité ou à une autre activité au même moment.',
                removedGuests:
                    "{guests} a été retiré(e) de la liste d'invités car il/elle est déjà inscrit(e) pour une passe donnant accès à cette activité ou à une autre activité au même moment.",
            },
        },
        tickets: {
            backToMyTicketsPasses: 'Retour à Mes billets / passes',
            registration: {
                registrant: {
                    onlyOneActivity:
                        "{note} les participants ne peuvent s'inscrire pour plus d'une activité durant le même créneau horaire ni à la même activité plus d'une fois.",
                },
                guest: {
                    guestFamilyWarning:
                        "Les invités ne peuvent être ajoutés que depuis votre {nintendoFamilyLink}. Si vous ne voyez pas les personnes que vous voulez inviter dans la liste ci-dessous, veuillez tout d'abord les ajouter au groupe familial de votre compte Nintendo.",
                    guestFamilyWarningNoFamily:
                        "Les invités ne peuvent être ajoutés que depuis votre {nintendoFamilyLink}. Actuellement, votre groupe familial ne possède aucun membre. Veuillez ajouter tout d'abord des membres au groupe familial de votre compte Nintendo.",
                    guestFamilyMessaging:
                        "Le lien pour gérer le groupe familial de votre compte Nintendo s'ouvrira dans une nouvelle fenêtre. Après la mise à jour de votre groupe familial, revenez dans cette page et sélectionnez les membres du groupe familial qui auront besoin d'un billet.",
                    guestFamilyMessagingPass:
                        "Le lien pour gérer le groupe familial de votre compte Nintendo s'ouvrira dans une nouvelle fenêtre. Après la mise à jour de votre groupe familial, revenez dans cette page et sélectionnez les membres du groupe familial qui auront besoin d'une passe.",
                    selectFamilyMember:
                        "Sélectionnez les membres du groupe familial qui auront besoin d'un billet.",
                    selectFamilyMemberPass:
                        "Sélectionnez les membres du groupe familial qui auront besoin d'une passe.",
                    confirmEntryTitle: 'Confirmer la participation',
                    confirmTicketsTitle: 'Confirmer des billets',
                    confirmPassesTitle: 'Confirmer les passes',
                    confirmEntryMessage:
                        "Vous êtes sur le point de confirmer votre participation au tirage pour {totalGuests} billets. Veuillez revoir la liste des participants au tirage pour recevoir un billet. Chaque participant âgé de 7 ans ou plus a besoin d'un billet pour participer.",
                    confirmTicketsMessage:
                        "Vous êtes sur le point de soumettre une réservation pour {totalGuests} billets. Veuillez revoir la liste des participants qui recevront un billet. Chaque participant âgé de 7 ans ou plus a besoin d'un billet pour participer.",
                    confirmPassesEntryMessage:
                        "Vous êtes sur le point de confirmer votre participation au tirage pour {totalGuests} passes. Veuillez revoir la liste des participants au tirage pour recevoir une passe. Chaque participant âgé de 7 ans ou plus a besoin d'une passe pour participer.",
                    confirmPassesMessage:
                        "Vous êtes sur le point de soumettre une réservation pour {totalGuests} passes. Veuillez vérifier la liste des participants qui recevront une passe. Chaque participant âgé de 7 ans ou plus a besoin d'une passe pour participer.",
                },
            },
            cancelTicket: {
                cancelTicketModalWarning: {
                    line2: 'Votre billet et votre passe seront annulés.',
                    line3: "L'annulation de votre billet annulera automatiquement les billet(s) et passe(s) pour tous les membres de votre groupe (le cas échéant). Tout le monde recevra un courriel de confirmation d'annulation.",
                    line4: "Toutes les annulations sont définitives. Les billets et les passes ne seront pas honorés en cas d'annulation.",
                },
            },
            cancelPass: {
                cancelTicketModalTitle: 'Annuler une passe',
                cancelLink: 'Annuler cette passe',
                areYouSure: 'Voulez-vous vraiment annuler cette passe ?',
                cancelButton: 'Annuler une passe',
            },
            cancelDrawingEntry: {
                cancelTicketModalWarning: {
                    line2: "L'annulation de votre participation au tirage annulera automatiquement les participations de tous les membres de votre groupe (le cas échéant). Tout le monde recevra un courriel de confirmation d'annulation.",
                },
            },
            cancelPassDrawingEntry: {
                cancelTicketModalTitle: 'Annuler une Passe',
                cancelTicketModalWarning: {
                    line1: 'Votre participation au tirage pour ce Warp Pipe Pass sera annulée.',
                    line2: "Annuler votre participation au tirage annulera automatiquement la participation au tirage de tous les membres de votre groupe (si applicable). Tout le monde recevra un courriel de confirmation d'annulation.",
                    line3: '',
                    line4: '',
                },
                areYouSure:
                    'Êtes-vous sûr(e) que vous souhaitez annuler cette participation au Warp Pipe Pass?',
                imSure: 'Je suis sûr(e)',
                cancelButton: 'Annuler la participation',
            },
            waitlist: {
                summaryCheckbox:
                    "En cochant cette case, je comprends que mon inscription sur la liste d'attente ne garantit pas l'obtention de billets ou ne signifie pas que je peux participer à l'événement. Si une offre se présente, j'aurai 36 heures pour l'accepter avant qu'elle n'expire. Seuls les titulaires d'un billet confirmé pourront accéder à l'événement.",
                makeChanges: 'Effectuer des changements',
            },
            filter: {
                ticketTypes: {
                    FAMILY: 'Billets familiaux',
                },
            },
        },
        error: {
            serviceError: {
                GP0010: "Vous êtes déjà inscrit(e). Les participants ne peuvent s'inscrire ni à plusieurs activités dans le même créneau horaire, ni à la même activité plus d'une fois.",
                GP0252: 'Vous possédez déjà une passe pour cette activité.',
            },
            timeSlotCancelingError: "Erreur lors de l'annulation de la passe",
        },
        account: {
            checkIn: {
                poorInternetConnectivity:
                    "En cas de mauvaise connexion internet lors de l'événement, nous vous recommandons d'imprimer cette passe soit à partir de cette page, soit à partir du courriel que nous vous avons envoyé à l'adresse courriel associée à votre compte Nintendo. (Si vous ne voyez pas ce courriel, veuillez vérifier votre dossier de courrier indésirable).",
            },
            passes: {
                warpPipePass: 'Passe',
                warpPipePasses: 'Passe',
            },
            rsvps: {
                rsvps: 'Billets et Passes',
                viewPass: 'Voir vos passes',
                warpPipePassAdded: 'Vous avez bien reçu votre passe pour {ticketName}.',
                details: {
                    pass: {
                        ios: require('../images/pass/ios/fr/apple_wallet_badge_ca.svg'),
                    },
                },
            },
        },
        noneFound: {
            warpPipePasses: 'Vous ne possédez actuellement aucune passe active',
        },
        footer: {
            disclaimer:
                "Les passes et/ou billets sont à usage unique, non transférables et ne peuvent pas être vendus. Les passes et/ou billets peuvent être échangeables contre un accès prioritaire à la file d'attente d'un jeu ou d'un événement sélectionné à une heure donnée et ne pas être échangeables s'ils sont utilisés à une heure différente. QR Code est une marque déposée de DENSO WAVE INCORPORATED. Nintendo trademarks are properties of Nintendo.",
            privacyPolicyUrl: 'https://www.nintendo.com/fr-ca/privacy-policy/',
            termsOfUse: "Conditions d'utilisation",
            termsOfUseUrl: 'https://www.nintendo.com/fr-ca/terms-of-use/',
        },
        dates: {
            hourMinute: 'HH [h] mm [HE]',
            hourMinutesTimezone: 'HH [h] mm [HE] zz',
            reservationTime: 'HH [h] mm [HE]',
            timeSlot: {
                timeSlotHourMinuteTimezone: 'HH [h] mm [HE] z',
                timeSlotHourMinute: 'HH [h] mm [HE]',
            },
            eventTickets: {
                same_day_time: 'HH [h] mm [HE]',
                time: 'HH [h] mm [HE]',
                cancel: {
                    time: 'dddd MMM D, YYYY - HH [h] mm [HE]',
                },
                waitlistClaimBy: 'H [h] mm [HE] [le] dddd DD MMMM',
            },
        },
    },
    fr_FR,
);

export default fr_CA;
